import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { CheckCircle } from 'lucide-react';
export function TrialForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
    }, 1500);
  };
  if (isSubmitted) {
    return <div className="bg-white p-8 rounded-xl shadow-lg border border-green-100 text-center" data-id="element-265">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-266">
          <CheckCircle className="w-8 h-8 text-green-600" data-id="element-267" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-268">
          Request Received!
        </h3>
        <p className="text-gray-600 mb-6" data-id="element-269">
          Thank you for your interest! We'll be in touch shortly to schedule
          your first class and get your uniform ready.
        </p>
        <p className="text-sm text-gray-500" data-id="element-270">
          Have questions? Call us at{' '}
          <a href="tel:8107753153" className="text-primary font-semibold" data-id="element-271">
            (810) 775-3153
          </a>
        </p>
      </div>;
  }
  return <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100" data-id="element-272">
      <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-273">
        Claim Your Trial
      </h3>
      <p className="text-gray-600 mb-6" data-id="element-274">
        Fill out the form below to reserve your spot.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-275">
        <Input label="Parent/Guardian Name" placeholder="Your full name" required data-id="element-276" />
        <Input label="Email Address" type="email" placeholder="you@example.com" required data-id="element-277" />
        <Input label="Phone Number" type="tel" placeholder="(555) 555-5555" required data-id="element-278" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-279">
          <Input label="Student Name" placeholder="Student's name" required data-id="element-280" />
          <Input label="Student Age" type="number" placeholder="Age" required data-id="element-281" />
        </div>
        <div className="pt-2" data-id="element-282">
          <Button type="submit" fullWidth size="lg" isLoading={isLoading} data-id="element-283">
            Claim Offer Now
          </Button>
        </div>
        <p className="text-xs text-center text-gray-500 mt-4" data-id="element-284">
          By submitting this form, you agree to be contacted by Limitless
          Taekwondo. We respect your privacy.
        </p>
      </form>
    </div>;
}